export default function hyphenCase(camelCase: string) {
  return camelCase.replace(/[A-Z]/g, m => `-${m.toLowerCase()}`);
}
